import {
  BlockStack,
  Button,
  InlineStack,
  Text
} from '@shopify/polaris';

export default function NoArticles() {

  return (
    <div className="AC-Container Full-Height">
      <div className="AC-Row Align-Center Justify-Center Full-Height">
        <div className="AC-Col Flex Center-X">
          <BlockStack align="center" gap="300">
            <Text as="h2" variant="headingXl" alignment="center">No articles</Text>
            <Text as="p" variant="bodyLg" alignment="center">Create your first article to get started</Text>
            <InlineStack align="center">
              <Button variant="primary" size="large" url="/articles/new">New article</Button>
            </InlineStack>
          </BlockStack>
        </div>

      </div>
    </div>
  )
}
